import React from "react";
import { Box, Stack, Skeleton } from "@mui/material";
import {
  CardBox,
  SaveBox,
  DetailsBox,
  FeatureBox,
  FeatureText,
} from "./styles";

const PricingCardSkeleton = () => {
  return (
    <CardBox sx={{ background: "#27B1BB" }}>
      <Stack
        sx={{
          display: "flex",
          flexDirection: { md: "row" },
          justifyContent: {
            md: "space-between",
            sm: "center",
            xs: "center",
          },
          alignItems: { sm: "center", xs: "center" },
          marginBottom: { sm: "20px", xs: "20px" },
          marginTop: "-10px",
        }}
      >
        <Skeleton
          variant="text"
          width={200}
          height={40}
          sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
        />
        <SaveBox sx={{ marginTop: { sm: "10px", xs: "10px" } }}>
          <Skeleton variant="text" width={80} height={30} />
        </SaveBox>
      </Stack>
      <Stack
        sx={{
          display: "flex",
          flexDirection: { md: "row" },
          width: "100%",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <DetailsBox sx={{ background: "#FFFFFF" }}>
          {[...Array(4)].map((_, index) => (
            <FeatureBox key={index} sx={{ border: "1px solid #27B1BB" }}>
              <FeatureText>
                <Skeleton variant="text" width={150} />
              </FeatureText>
            </FeatureBox>
          ))}
        </DetailsBox>
        <Stack direction="column">
          <Box sx={{ px: 1, marginBottom: "20px" }}>
            <Skeleton
              variant="text"
              width={100}
              height={30}
              sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
            />
            <Skeleton
              variant="rectangular"
              width={150}
              height={40}
              sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
            />
          </Box>
          <Box sx={{ paddingLeft: "20px", marginBottom: "20px", px: 1 }}>
            <Skeleton
              variant="rectangular"
              width={150}
              height={50}
              sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
            />
          </Box>
        </Stack>
        <Skeleton
          variant="text"
          width={120}
          height={100}
          sx={{ bgcolor: "rgba(255,255,255,0.3)" }}
        />
      </Stack>
    </CardBox>
  );
};

const ContentSkeleton = () => {
  return (
    <Box sx={{ width: "100%", my: 4 }}>
      <Skeleton
        variant="text"
        width="60%"
        height={40}
        sx={{ mx: "auto", mb: 2 }}
      />
      {[...Array(10)].map((_, index) => (
        <Skeleton key={index} variant="text" width="100%" sx={{ mb: 1 }} />
      ))}
    </Box>
  );
};

export { PricingCardSkeleton, ContentSkeleton };
